import Super from './-resources';
import classic from 'ember-classic-decorator';

@classic
export default class SiteBillingStatements extends Super {}
